/* CORNER: reusable original-photo browsing and one shopping-bag icon. */
(()=>{
 'use strict';
 const bagPaths='<path d="M5.5 7.5h13l1.2 13h-15l.8-13Z"/><path d="M8.5 9V6a3.5 3.5 0 0 1 7 0v3"/>';
 const cartSelector='.sf-cart-icon svg,.corner-card-cart svg,.corner-model__cart svg,.corner-mobile-cart svg,.corner-mobile-cart-link svg';
 function bags(){document.querySelectorAll(cartSelector).forEach(svg=>{
   if(svg.classList.contains('corner-shopping-bag'))return;
   svg.setAttribute('viewBox','0 0 24 24');svg.classList.add('corner-shopping-bag');
   // Retain the header adapter's sentinel, avoiding competing observers.
   if(svg.closest('.sf-cart-icon'))svg.classList.add('corner-header-action-icon');
   svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');svg.innerHTML=bagPaths;
 });}
 let queued=false;
 function scan(){queued=false;bags();/* Product cards keep their original first image and native link. */}
 function schedule(){if(!queued){queued=true;requestAnimationFrame(scan)}}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
 new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&!n.matches('.ccg-track,.ccg-slide,.ccg-slide-image,.ccg-dots,.ccg-control,.ccg-dots i,svg.corner-shopping-bag path'))))schedule()}).observe(document.documentElement,{childList:true,subtree:true});
})();
